import isEmptyString from '@lib/utilities/text/isEmptyString'

export default function getUserFirstName(user: { name?: string | null }) {
  return getFirstName(user.name)
}

export function getFirstName(name?: string | null) {
  const splitName = (name ?? '').trim().split(/\s+/)

  if (splitName.length > 1) {
    return splitName[0]!.trim()
  }

  if (typeof name === 'string' && !isEmptyString(name)) {
    return name.trim()
  }

  return
}
